import AbstractRepository from '@services/repositories/AbstractRepository';

export default class ShippingComplaintRepository extends AbstractRepository {
    constructor() {
        super();
        this.setApiUrl('/vue/shipping/complaint/list');
    }
}
